import { render, staticRenderFns } from "./ProductExpand.vue?vue&type=template&id=7737af4e&"
import script from "./ProductExpand.vue?vue&type=script&lang=js&"
export * from "./ProductExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/ProductExpand.vue
// module id = null
// module chunks = 